import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useMemo,
  useState,
} from 'react';

interface EnterprisesContextData {
  enterprisesCount: number | undefined;
  setEnterprisesCount: Dispatch<SetStateAction<number | undefined>>;
}

export const EnterprisesContext = createContext<
  EnterprisesContextData | undefined
>(undefined);

const EnterprisesProvider = ({ children }: { children: ReactNode }) => {
  const [enterprisesCount, setEnterprisesCount] = useState<
    number | undefined
  >();

  const contextValue = useMemo(
    () => ({
      enterprisesCount,
      setEnterprisesCount,
    }),
    [enterprisesCount],
  );

  return (
    <EnterprisesContext.Provider value={contextValue}>
      {children}
    </EnterprisesContext.Provider>
  );
};

export default EnterprisesProvider;
